module.exports = __webpack_public_path__ + "img/oman.6b2dfba0.svg";